<template>
  <div class="home-kpi-grid-container">
    <!-- Section 1: GA4 Analytics Metrics -->
    <div class="kpi-group-section">
      <div class="section-badge-header">
        <div class="badge-tag tag-ga4">
          <i class="fas fa-chart-line"></i>
          <span>LƯU LƯỢNG TRUY CẬP & TƯƠNG TÁC SỐ (GA4)</span>
        </div>
        <span class="range-subtext">Dữ liệu thống kê: {{ rangeLabel }}</span>
      </div>

      <div class="kpi-cards-row">
        <!-- 1. Active Users -->
        <div class="kpi-card card-users">
          <div class="card-top">
            <span class="card-title">Người dùng hoạt động</span>
            <div class="icon-wrap bg-green-light">
              <i class="fas fa-user-friends icon-green"></i>
            </div>
          </div>
          <div class="card-main-val">{{ formatNumber(kpis.activeToday || 0) }}</div>
          <div class="card-bottom">
            <span class="bottom-hint">Khách truy cập trong kỳ</span>
            <span class="stat-pill pill-live">
              <i class="fas fa-circle live-dot"></i> Live
            </span>
          </div>
        </div>

        <!-- 2. Page Views -->
        <div class="kpi-card card-pageviews">
          <div class="card-top">
            <span class="card-title">Lượt xem trang</span>
            <div class="icon-wrap bg-purple-light">
              <i class="far fa-eye icon-purple"></i>
            </div>
          </div>
          <div class="card-main-val">{{ formatNumber(kpis.totalPageViews || 0) }}</div>
          <div class="card-bottom">
            <span class="bottom-hint">Tổng số lượt tải trang web</span>
            <span class="stat-pill pill-neutral">GA4 Traffic</span>
          </div>
        </div>

        <!-- 3. QR Code Scans -->
        <div class="kpi-card card-qr">
          <div class="card-top">
            <span class="card-title">Lượt quét mã QR</span>
            <div class="icon-wrap bg-pink-light">
              <i class="fas fa-qrcode icon-pink"></i>
            </div>
          </div>
          <div class="card-main-val">{{ formatNumber(kpis.totalQrScans || 0) }}</div>
          <div class="card-bottom">
            <span class="bottom-hint">Tại điểm du lịch & dịch vụ</span>
            <span class="stat-pill pill-pink">Tương tác thực tế</span>
          </div>
        </div>

        <!-- 4. Search Queries -->
        <div class="kpi-card card-searches">
          <div class="card-top">
            <span class="card-title">Lượt tìm kiếm</span>
            <div class="icon-wrap bg-yellow-light">
              <i class="fas fa-search icon-yellow"></i>
            </div>
          </div>
          <div class="card-main-val">{{ formatNumber(kpis.totalSearches || 0) }}</div>
          <div class="card-bottom">
            <span class="bottom-hint">Nhu cầu tra cứu thông tin</span>
            <span class="stat-pill pill-yellow">Search Intent</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2: CMS Module Statistics -->
    <div class="kpi-group-section mt-4">
      <div class="section-badge-header">
        <div class="badge-tag tag-cms">
          <i class="fas fa-database"></i>
          <span>THỐNG KÊ SỐ LIỆU CÁC MODULE DU LỊCH, DỊCH VỤ & NỘI DUNG (CSDL)</span>
        </div>
        <span class="range-subtext">Hệ thống quản lý điểm đến, dịch vụ & bài viết</span>
      </div>

      <div class="kpi-cards-row cms-modules-grid">
        <div
          v-for="mod in moduleCards"
          :key="mod.key"
          class="kpi-card"
        >
          <div class="card-top">
            <span class="card-title">{{ mod.title }}</span>
            <div :class="['icon-wrap', mod.bgClass]">
              <i :class="[mod.icon, mod.iconClass]"></i>
            </div>
          </div>
          <div class="card-main-val">
            {{ formatNumber(getModuleStat(mod.key, 'total', 0)) }}
            <span class="val-unit">{{ mod.unit }}</span>
          </div>
          <div class="card-bottom metrics-detail">
            <span>❤️ {{ formatNumber(getModuleStat(mod.key, 'likes', 0)) }} {{ mod.likeLabel }}</span>
            <span class="rating-badge">⭐ {{ getModuleStat(mod.key, 'rating', '5.0') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export const CMS_MODULE_CARDS = [
  {
    key: 'attraction',
    placeType: 'attraction',
    title: 'Danh thắng',
    unit: 'điểm',
    likeLabel: 'yêu thích',
    icon: 'fas fa-place-of-worship',
    bgClass: 'bg-blue-light',
    iconClass: 'icon-blue'
  },
  {
    key: 'stay',
    placeType: 'stay',
    title: 'Lưu trú',
    unit: 'cơ sở',
    likeLabel: 'yêu thích',
    icon: 'fas fa-bed',
    bgClass: 'bg-indigo-light',
    iconClass: 'icon-indigo'
  },
  {
    key: 'event',
    placeType: 'event',
    title: 'Sự kiện',
    unit: 'sự kiện',
    likeLabel: 'quan tâm',
    icon: 'fas fa-calendar-week',
    bgClass: 'bg-yellow-light',
    iconClass: 'icon-yellow'
  },
  {
    key: 'entertainment',
    placeType: 'entertainment',
    title: 'Giải trí',
    unit: 'điểm',
    likeLabel: 'yêu thích',
    icon: 'fas fa-play-circle',
    bgClass: 'bg-pink-light',
    iconClass: 'icon-pink'
  },
  {
    key: 'cuisine',
    placeType: 'cuisine',
    title: 'Ăn uống',
    unit: 'địa điểm',
    likeLabel: 'yêu thích',
    icon: 'fas fa-utensils',
    bgClass: 'bg-orange-light',
    iconClass: 'icon-orange'
  },
  {
    key: 'tour',
    placeType: 'tour',
    title: 'Tour',
    unit: 'tour',
    likeLabel: 'yêu thích',
    icon: 'fas fa-route',
    bgClass: 'bg-teal-light',
    iconClass: 'icon-teal'
  },
  {
    key: 'company',
    placeType: 'company',
    title: 'Doanh nghiệp',
    unit: 'đơn vị',
    likeLabel: 'quan tâm',
    icon: 'fas fa-building',
    bgClass: 'bg-violet-light',
    iconClass: 'icon-violet'
  },
  {
    key: 'tourGuide',
    placeType: 'tour-guide',
    title: 'Hướng dẫn viên',
    unit: 'HDV',
    likeLabel: 'yêu thích',
    icon: 'fas fa-user-tie',
    bgClass: 'bg-cyan-light',
    iconClass: 'icon-cyan'
  },
  {
    key: 'post',
    placeType: 'post',
    title: 'Bài viết Blog - Chia sẻ',
    unit: 'bài viết',
    likeLabel: 'tương tác',
    icon: 'far fa-newspaper',
    bgClass: 'bg-emerald-light',
    iconClass: 'icon-emerald'
  }
]

export default {
  name: 'HomeKpiGrid',
  props: {
    kpis: {
      type: Object,
      default: () => ({})
    },
    cmsStats: {
      type: Object,
      default: () => ({})
    },
    rangeLabel: {
      type: String,
      default: '30 phút qua'
    }
  },
  data() {
    return {
      moduleCards: CMS_MODULE_CARDS
    }
  },
  methods: {
    getModuleStat(key, field, fallback) {
      const mod = this.cmsStats && this.cmsStats[key]
      if (mod && mod[field] !== undefined && mod[field] !== null) {
        return mod[field]
      }
      return fallback
    },
    formatNumber(num) {
      if (num === undefined || num === null) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-kpi-grid-container {
  margin-bottom: 24px;

  .kpi-group-section {
    &.mt-4 {
      margin-top: 20px;
    }

    .section-badge-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      flex-wrap: wrap;
      gap: 8px;

      .badge-tag {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 4px 10px;
        border-radius: 6px;
        font-size: 11.5px;
        font-weight: 800;
        letter-spacing: 0.4px;

        &.tag-ga4 {
          background-color: #eff6ff;
          color: #1d4ed8;
          border: 1px solid #bfdbfe;
        }

        &.tag-cms {
          background-color: #faf5ff;
          color: #7e22ce;
          border: 1px solid #e9d5ff;
        }
      }

      .range-subtext {
        font-size: 12px;
        color: #64748b;
        font-weight: 500;
      }
    }

    .kpi-cards-row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 640px) {
        grid-template-columns: 1fr;
      }

      &.cms-modules-grid {
        grid-template-columns: repeat(3, 1fr);

        @media (max-width: 1100px) {
          grid-template-columns: repeat(2, 1fr);
        }

        @media (max-width: 640px) {
          grid-template-columns: 1fr;
        }
      }
    }
  }

  .kpi-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 18px 20px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
    transition: all 0.25s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 125px;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(15, 23, 42, 0.07);
      border-color: #cbd5e1;
    }

    .card-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .card-title {
        font-size: 13px;
        font-weight: 700;
        color: #475569;
        text-transform: uppercase;
        letter-spacing: 0.3px;
      }

      .icon-wrap {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;

        &.bg-green-light { background: #dcfce7; }
        &.bg-purple-light { background: #f3e8ff; }
        &.bg-pink-light { background: #fce7f3; }
        &.bg-yellow-light { background: #fef3c7; }
        &.bg-blue-light { background: #e0f2fe; }
        &.bg-indigo-light { background: #e0e7ff; }
        &.bg-orange-light { background: #ffedd5; }
        &.bg-teal-light { background: #ccfbf1; }
        &.bg-violet-light { background: #ede9fe; }
        &.bg-emerald-light { background: #d1fae5; }
        &.bg-cyan-light { background: #cffafe; }
      }
    }

    .card-main-val {
      font-size: 26px;
      font-weight: 800;
      color: #0f172a;
      line-height: 1.1;
      margin-bottom: 12px;

      .val-unit {
        font-size: 14px;
        font-weight: 600;
        color: #64748b;
        margin-left: 4px;
      }
    }

    .card-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #64748b;
      font-weight: 500;
      border-top: 1px dashed #f1f5f9;
      padding-top: 8px;

      &.metrics-detail {
        font-size: 12px;
        font-weight: 600;
        color: #475569;
      }

      .rating-badge {
        background: #fffbeb;
        color: #b45309;
        border: 1px solid #fde68a;
        padding: 2px 6px;
        border-radius: 4px;
        font-weight: 700;
      }

      .stat-pill {
        font-size: 11px;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 12px;

        &.pill-live {
          background: #ecfdf5;
          color: #059669;
          display: inline-flex;
          align-items: center;
          gap: 4px;

          .live-dot {
            font-size: 6px;
            animation: pulse-dot 1.5s infinite;
          }
        }

        &.pill-neutral { background: #f1f5f9; color: #475569; }
        &.pill-pink { background: #fdf2f8; color: #db2777; }
        &.pill-yellow { background: #fefce8; color: #ca8a04; }
        &.pill-violet { background: #f5f3ff; color: #7c3aed; }
        &.pill-cyan { background: #ecfeff; color: #0891b2; }
      }

      .trend-badge-up {
        color: #059669;
        font-weight: 700;
        font-size: 11.5px;
      }
    }
  }
}

.icon-green { color: #10b981; }
.icon-purple { color: #8b5cf6; }
.icon-pink { color: #ec4899; }
.icon-yellow { color: #f59e0b; }
.icon-blue { color: #0284c7; }
.icon-indigo { color: #4f46e5; }
.icon-orange { color: #ea580c; }
.icon-teal { color: #0d9488; }
.icon-violet { color: #7c3aed; }
.icon-emerald { color: #059669; }
.icon-cyan { color: #0891b2; }

@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
</style>
